export const SET_LOADING = 'SET_LOADING'

// reducer
export const LOADING_STATE_KEY = 'loading'
